import styled from "@emotion/styled"
import { PHeading, PInlineNotification, PText } from "@porsche-design-system/components-react"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"
import { shouldForwardProp } from "src/common/shouldForwardProp"

// The scheduled window is Nov 3rd 2026, 11:00–13:30 CET (UTC+01:00).
const maintenanceWindowStart = new Date("2026-11-03T10:00:00Z")
const maintenanceWindowEnd = new Date("2026-11-03T12:30:00Z")

const messages = defineMessages({
	description: {
		defaultMessage:
			"Due to scheduled WWS maintenance on {maintenanceWindow}, vehicles sold as Porsche Approved that require warranty registration cannot be delivered during this time. Please complete these deliveries beforehand or try again after the maintenance.",
		id: "porscheApprovedDeliveryDowntimeAnnouncement.description",
	},
	title: {
		defaultMessage: "Scheduled WWS maintenance",
		id: "porscheApprovedDeliveryDowntimeAnnouncement.title",
	},
})

interface PorscheApprovedDeliveryDowntimeAnnouncementProps {
	hasTopMargin?: boolean
}

export const PorscheApprovedDeliveryDowntimeAnnouncement = ({
	hasTopMargin = true,
}: PorscheApprovedDeliveryDowntimeAnnouncementProps) => {
	const { formatDateTimeRange } = useIntl()
	const maintenanceWindow = formatDateTimeRange(maintenanceWindowStart, maintenanceWindowEnd, {
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
		month: "long",
		timeZoneName: "short",
		weekday: "long",
		year: "numeric",
	})

	return (
		<StyledInlineNotification $hasTopMargin={hasTopMargin} state="warning" dismissButton={false}>
			<PHeading slot="heading" tag="h3" size="sm" weight="bold">
				<FormattedMessage {...messages.title} />
			</PHeading>
			<PText>
				<FormattedMessage {...messages.description} values={{ maintenanceWindow }} />
			</PText>
		</StyledInlineNotification>
	)
}

const StyledInlineNotification = styled(PInlineNotification, { shouldForwardProp })<{ $hasTopMargin: boolean }>`
	margin-top: ${({ $hasTopMargin }) => ($hasTopMargin ? spacingStaticMd : 0)};
`
